<template>
  <div class="modal fade" id="modalConfirmacion" tabindex="-1" role="dialog" aria-labelledby="modalConfirmacion" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{titulo}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h5><span class="col-form-label">{{cuerpo}}</span></h5>
          <br />
          <input type="date" v-model="fecha" class="form-control"/>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-primary" id="botonModalConfirmacion" data-dismiss="modal" v-bind:disabled="!validarFecha">Confirmar</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import Vue from 'vue'

  export default {
    props: {
      method: {type: Function},
    },
    data() {
      return {
        titulo: "",
        cuerpo: "",
        fecha: ""
      }
    },
    components: {
      validarFecha: function () {
        return this.fecha != null && this.fecha != "" 
      }
    },
    methods: {
      mostrar: function (titulo, cuerpo, accion) {
        console.log('mostrar del captura fecha');
        this.titulo = titulo
        this.cuerpo = cuerpo
        $('#botonModalConfirmacion').attr("disabled", true)
        this.fecha = "";
        $('#modalConfirmacion').modal('show')
        $("#botonModalConfirmacion").unbind('click').click(this.accionChida);
      },
      accionChida: function () {
        this.$emit('accion', this.fecha)
      }
      
    },
    computed: {
    validarFecha: function() {
      return this.fecha != null && this.fecha != "";
    }
    },
    mounted: function () {

    }

  }
</script>

<style scoped>
  .modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1050;
    /* display: none; */
    overflow: hidden;
    outline: 0;
  }
  .modal-content {
      background-color:  #7e7f74;
  }
  .modal-header {
        background-color:  #007573;
    }
</style>



// WEBPACK FOOTER //
// src/components/SIAP/Comun/Modales/ModalCapturaFecha.vue